"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var currency_js_1 = __importDefault(require("currency.js"));
var React = __importStar(require("react"));
var react_1 = require("react");
var selected_variant_state_1 = require("../../misc/selected-variant-state");
var unavailable_regions_1 = require("../../utils/unavailable-regions");
var unavailable_in_region_disclaimer_1 = __importDefault(require("../shared-components/unavailable-in-region-disclaimer"));
var renderButton = function (handleAddToCartClick, isAddingToCart, hidePrice, selectedVariant, quantity, enableOutOfStockLogic, buttonHeight) {
    if (!selectedVariant)
        return null;
    // TODO: Do we ever really not want this behavior when a variant is unavailable?
    // We can consider getting rid of enableOutOfStockLogic and always showing the Out of Stock button when the variant is unavailable.
    if (enableOutOfStockLogic && !selectedVariant.available) {
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { className: 'hide-for-medium width-100 bg-alto padding-horizontal-5 padding-vertical-2', disabled: true, style: { height: buttonHeight } }, "Out of Stock"),
            React.createElement("button", { className: 'show-for-medium width-100 bg-alto text-black bordered border-wisteria padding-horizontal-5 padding-vertical-2', disabled: true, style: { height: buttonHeight } }, "Out of Stock")));
    }
    var priceDisplay = (function () {
        var variantPrice = selectedVariant && Number(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price);
        return variantPrice && "$".concat((0, currency_js_1.default)(variantPrice).multiply(quantity).toString());
    })();
    var addToCartButtonText = 'Add to Cart';
    if (!hidePrice)
        addToCartButtonText += " - ".concat(priceDisplay);
    var compareAtPriceDisplay = (function () {
        var variantCompareAtPrice = selectedVariant && Number(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.compare_at_price);
        return variantCompareAtPrice ? "$".concat((0, currency_js_1.default)(variantCompareAtPrice, { fromCents: true }).multiply(quantity).toString()) : null;
    })();
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: 'hide-for-medium width-100 bg-wisteria text-white padding-horizontal-5 padding-vertical-2', disabled: false, onClick: handleAddToCartClick, style: { height: buttonHeight } }, isAddingToCart ? ('Adding to cart...') : (React.createElement(React.Fragment, null,
            addToCartButtonText,
            !hidePrice && compareAtPriceDisplay && React.createElement("span", { className: 'strike padding-left-2' }, compareAtPriceDisplay)))),
        React.createElement("button", { className: 'show-for-medium width-100 bg-white text-black bordered border-wisteria padding-horizontal-5 padding-vertical-2', disabled: false, onClick: handleAddToCartClick, style: { height: buttonHeight } }, isAddingToCart ? ('Adding to cart...') : (React.createElement(React.Fragment, null,
            addToCartButtonText,
            !hidePrice && compareAtPriceDisplay && React.createElement("span", { className: 'strike text-gray padding-left-2' }, compareAtPriceDisplay))))));
};
var PdpAddToCart = function (_a) {
    var nonShoppableSiteSettings = _a.nonShoppableSiteSettings, hidePrice = _a.hidePrice, enableOutOfStockLogic = _a.enableOutOfStockLogic, onDoneAddingToCart = _a.onDoneAddingToCart;
    var selectedVariant = (0, selected_variant_state_1.useSelectedVariantStore)(function (state) { return state.variant; });
    var _b = window.variantSelectorApp, hideAddToCartButton = _b.hideAddToCartButton, hideBundleButtonDesktop = _b.hideBundleButtonDesktop, hideBundleButtonMobile = _b.hideBundleButtonMobile, bundleAndSaveButtonLink = _b.bundleAndSaveButtonLink, bundleAndSaveButtonText = _b.bundleAndSaveButtonText, exclamationTriangleIconURL = _b.exclamationTriangleIconURL;
    var _c = __read((0, react_1.useState)(1), 2), quantity = _c[0], setQuantity = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isAddingToCart = _d[0], setIsAddingToCart = _d[1];
    var handleDecreaseQuantity = function () {
        // don't decrease quantity if it's already 1
        if (quantity <= 1)
            return;
        setQuantity(quantity - 1);
    };
    var handleIncreaseQuantity = function () {
        setQuantity(quantity + 1);
    };
    var handleAddToCartClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var properties;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedVariant)
                        return [2 /*return*/];
                    setIsAddingToCart(true);
                    properties = (0, unavailable_regions_1.addUnavailableRegionsToCartLineProperties)({}, selectedVariant.product.tags);
                    return [4 /*yield*/, window.cartApp.add([[selectedVariant.id, { properties: properties, quantity: quantity }]])];
                case 1:
                    _a.sent();
                    setIsAddingToCart(false);
                    if (onDoneAddingToCart)
                        onDoneAddingToCart(selectedVariant);
                    return [2 /*return*/];
            }
        });
    }); };
    var buttonHeight = 48;
    return (React.createElement(React.Fragment, null,
        nonShoppableSiteSettings.enabled && nonShoppableSiteSettings.buttonText && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'width-100 hide-for-medium' },
                React.createElement("a", { className: 'bg-wisteria text-white padding-5 display-block text-center', style: { height: buttonHeight }, href: nonShoppableSiteSettings.buttonLink, target: '_blank' }, nonShoppableSiteSettings.buttonText)),
            React.createElement("div", { className: 'show-for-medium width-100' },
                React.createElement("a", { className: 'bg-white text-black bordered border-wisteria padding-5 text-center display-block', style: { height: buttonHeight }, href: nonShoppableSiteSettings.buttonLink, target: '_blank' }, nonShoppableSiteSettings.buttonText)))),
        !hideAddToCartButton && !(nonShoppableSiteSettings === null || nonShoppableSiteSettings === void 0 ? void 0 : nonShoppableSiteSettings.enabled) && (React.createElement(React.Fragment, null,
            React.createElement(unavailable_in_region_disclaimer_1.default, { productTags: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.product.tags) || [], iconUrl: exclamationTriangleIconURL, unavailableClassName: 'text-xs font-bold margin-bottom-1' }),
            React.createElement("div", { className: 'width-100', style: { display: 'inline-flex' } },
                React.createElement("div", { className: 'flex-container margin-right-2', style: { height: buttonHeight, marginTop: 'auto', border: 'solid', borderWidth: 'thin' } },
                    React.createElement("a", { onClick: handleDecreaseQuantity, className: 'padding-horizontal-2 h6 margin-right-1', style: { margin: 'auto' } }, "-"),
                    React.createElement("span", { style: { margin: 'auto' } }, quantity),
                    React.createElement("a", { onClick: handleIncreaseQuantity, className: 'padding-horizontal-2 h6 margin-left-1', style: { margin: 'auto' } }, "+")),
                React.createElement("div", { className: 'width-100' }, renderButton(handleAddToCartClick, isAddingToCart, hidePrice, selectedVariant, quantity, enableOutOfStockLogic, buttonHeight))))),
        bundleAndSaveButtonText && (React.createElement("div", { className: (0, classnames_1.default)('width-100 text-center padding-top-2', hideBundleButtonMobile && 'hide-for-small-only', hideBundleButtonDesktop && 'hide-for-medium'), style: { fontSize: '15px' } },
            React.createElement("button", { className: 'width-100 bg-wisteria text-white padding-5', onClick: function () { return (window.location.href = bundleAndSaveButtonLink); }, style: { height: buttonHeight } }, bundleAndSaveButtonText)))));
};
exports.default = PdpAddToCart;
